module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"AI Try-on photo guide","description_title":"Share your try-on photo.","description_content":"When you attach a photo, AI will analyze it to determine if it is a try-on photo. Please upload photos showing body parts (eyes, nose, mouth, arms, legs, waist, etc.) while wearing the product.","disclaimer":"*Analyzed by an AI model; slight discrepancies may occur."}}')
  delete Component.options._Ctor
}
